module.exports = __webpack_public_path__ + "img/BadenIstSchön.c44e4ab3.jpg";